import { render, staticRenderFns } from "./xianfengsgStore.vue?vue&type=template&id=3026face&scoped=true&"
import script from "./xianfengsgStore.vue?vue&type=script&lang=js&"
export * from "./xianfengsgStore.vue?vue&type=script&lang=js&"
import style0 from "./xianfengsgStore.vue?vue&type=style&index=0&id=3026face&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3026face",
  null
  
)

export default component.exports